import React from 'react';
import createCtx from 'coreUtils/createCtx';

const [useAccordion, AccordionProvider] = createCtx<{
    togglerRef: React.MutableRefObject<HTMLDivElement>;
    handleListOpen: () => void;
    isOpen: boolean;
    expandIcon: string;
    collapseIcon: string;
}>();

export {useAccordion, AccordionProvider};